import React from 'react';
import './Account_step_1.css';

class Account_step_1 extends React.Component {
    render () {
        const showAt = this.props.showAtStep != null ? this.props.showAtStep : 1;
        if (this.props.currentStep !== showAt) {
            return null;
        }

        const errors = this.props.field_errors || {};

        return (
           <div>
                <h2 className='center'>What should we call you?</h2>
                <p className='center small_text signup_field_helper'>
                Please use the name on your ID. We need it to send gifts and to verify your account.
                </p>
                
                <form>
                    <p className='form_label'>First name </p>
                    <input 
                        type='text' 
                        id='user_first_name' 
                        onChange={this.props.handleChange}
                        name='first_name' 
                        placeholder='Jane' 
                        value={this.props.first_name}
                        autoFocus
                        maxLength='50'
                        autoComplete='given-name'
                        />
                    {errors.first_name ? <p className='tiny_text signup_field_error'>{errors.first_name}</p> : null}
                    
                    <p className='form_label'>Last name </p>
                    
                    <input 
                        type='text' 
                        id='user_last_name' 
                        onChange={this.props.handleChange}
                        name='last_name' 
                        placeholder='Diaz' 
                        value={this.props.last_name}
                        maxLength='50'
                        autoComplete='family-name'
                        />
                    {errors.last_name ? <p className='tiny_text signup_field_error'>{errors.last_name}</p> : null}
                    
                </form>

                
           </div>
        );
    }
}

export default Account_step_1;
